import InputField from "components/fields/InputField";
import Modal from "components/modal";
import Button from "components/button";

import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import LoaderButton from "components/button/LoaderButton";
import { editUsers } from "store/userSlice";

function PasswordUserModal({ userData, isOpen, onClose, refreshUserList }) {
  const dispatch = useDispatch();
  const { editError, editLoading } = useSelector((state) => state.users);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      password: "",
    },
    mode: "onBlur",
  });

  useEffect(() => {
    if (userData) {
      reset({
        _id: userData._id,
        password: "",
      });
    }
  }, [userData, reset]);
  const onSubmit = async (data) => {
    try {
      const response = await dispatch(editUsers(data));

      // Check for success
      if (
        response?.payload?.statuscode === 201 ||
        response?.payload?.statuscode === 200
      ) {
        refreshUserList();
        onClose();
        reset();
      } else {
        console.error(
          "Create failed:",
          response?.payload?.msg || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Create failed:", error);
    }
  };

  return (
    <div>
      <Modal isOpen={isOpen} onClose={onClose} className="max-w-lg">
        <h2 className="border-b py-3 pl-2 text-xl font-bold text-navy-700 dark:text-white">
          Add User
        </h2>

        <div className="mt-5 w-full max-w-4xl flex-col items-center lg:pl-0">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="mx-auto grid w-full grid-cols-1 gap-4"
            noValidate
          >
            <div className="grid grid-cols-1 gap-4 md:grid-cols-1">
              <InputField
                id="password"
                variant="auth"
                label="Password*"
                placeholder="Min. 8 characters"
                type="password"
                autoComplete="new-password"
                error={errors.password}
                {...register("password", {
                  required: "Password is required",
                  minLength: {
                    value: 8,
                    message: "At least 8 characters required",
                  },
                })}
              />

              {editError && (
                <div className="mt-2 grid grid-cols-1 gap-5 lg:grid-cols-1">
                  <p className="text-sm text-red-500">{editError}</p>
                </div>
              )}
            </div>

            <div className="flex items-center justify-end gap-2 pt-2">
              <Button type="button" variant="outline" onClick={onClose}>
                Cancel
              </Button>

              <LoaderButton type="submit" isLoading={editLoading}>
                Update
              </LoaderButton>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
}

export default PasswordUserModal;
